import type { FAQItem } from './types';

export const analyticsFAQs: FAQItem[] = [
  {
    id: 'analytics-available',
    question: 'What analytics are planned for boards and managers?',
    answer: `Analytics is a planned capability, not live today. The design intent, tiered by package, includes:

• Governance: voter participation, proposal outcomes, meeting attendance
• Finance: budget vs. actuals, revenue/expense trends, fee collection rates
• Operations: work order completion times, vendor performance
• Facilities: amenity utilization, peak hours, fee revenue

This depends on the underlying governance, finance, and work order data persisting, which is not yet built.`,
    category: 'analytics',
  },
  {
    id: 'analytics-kpis',
    question: 'Which analytics and KPIs are planned?',
    answer: `None of the following is live today; this describes design intent:

• **Governance:** voter participation, proposal approvals, meeting attendance
• **Finance:** dues collection rates, budget vs actuals, revenue/expense trends
• **Operations:** work order cycle times, vendor performance
• **Facilities:** utilization by amenity, peak times, fee revenue

Deeper dashboards and CSV export for Professional/Enterprise tiers are planned, not built.`,
    category: 'analytics',
  },
  {
    id: 'analytics-export-schedule',
    question: 'Will we be able to export reports for board packets or audits?',
    answer: `Exporting is planned, not built. The intent is to support exports for financials, governance records, and operations metrics, with scheduled exports for Professional/Enterprise and role-based permissions respected throughout. Ask us for current status before relying on exports for a board packet or audit.`,
    category: 'analytics',
  },
  {
    id: 'api-limits',
    question: 'Is there an API and are there usage limits?',
    answer: `Not yet. A public API with key issuance and usage quotas is on the roadmap but does not exist in the platform today. Tier-based limits and expanded integrations/webhooks would be defined once the API is built. Ask us for current status before planning an integration against it.`,
    category: 'analytics',
  },
];
